import { AppError } from "config/errors";
import {
  disclosureQuery,
  disclosureWithBodyQuery,
  businessDisclosuresQuery,
} from "gql/queries/disclosure";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const getDisclosure = createAsyncThunk(
  "disclosure/getDisclosure",
  async ({ slug }: { slug: string }, { rejectWithValue }) => {
    try {
      const response = await disclosureQuery(slug);

      return response.data.disclosure;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);

export const getDisclosureWithBody = createAsyncThunk(
  "disclosure/getDisclosureWithBody",
  async ({ slug }: { slug: string }, { rejectWithValue }) => {
    try {
      const response = await disclosureWithBodyQuery(slug);

      return response.data.disclosure;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);

export const getBusinessDisclosures = createAsyncThunk(
  "disclosure/getBussinessDisclosures",
  async ({ businessSlug }: { businessSlug: string }, { rejectWithValue }) => {
    try {
      const response = await businessDisclosuresQuery(businessSlug);

      return response.data.businessDisclosures;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
